<app-course-player-results-diploma
    (repeatCourse)="repeatCourse.emit($event)"
    [rewardType]="rewardType"
    [opportunity]="opportunity"
    [resource]="resource"
    [user]="user"
></app-course-player-results-diploma>
